function getLang() {
  return window.config.lang;
}
global.getLang = getLang;

function getCitySlug() {
  return window.config.city_slug;
}

global.getCitySlug = getCitySlug;

function normalizeDate(raw) {
  if (!raw) return '';
  // From "DD.MM.YY" or "DD.MM.YYYY" -> "YYYY-MM-DD"
  if (/^\d{2}\.\d{2}\.\d{2,4}$/.test(raw)) {
    const [dd, mm, yy] = String(raw).split('.');
    const yyyy = yy.length === 2 ? `20${yy}` : yy;
    return `${yyyy}-${mm.padStart(2, '0')}-${dd.padStart(2, '0')}`;
  }
  // Already ISO
  if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) return raw;

  // Try parsing anything else into ISO
  const d = new Date(raw);
  if (!isNaN(d)) {
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${day}`;
  }
  return raw;
}
